import React, { useEffect, useState } from "react";
import QuestsBanner from "../../../../assets/images/questsBanner.png";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const HeroCard = ({ selectedIndex, topUsers }) => {
  const [topData, setTopData] = useState(null);
  const [showFullAnswer, setShowFullAnswer] = useState(false);

  useEffect(() => {
    const fetchTopAnswer = async () => {
      const user = topUsers[selectedIndex];
      if (!user?.username) return;

      try {
        const res = await fetch(`${BACKEND_URL}/answers/top/${user.username}`);
        const data = await res.json();
        if (res.ok) {
          setTopData(data);
          setShowFullAnswer(false); // reset view toggle on hero change
        } else {
          console.warn("⚠️ Failed to fetch top answer:", data.message);
        }
      } catch (err) {
        console.error("❌ Error fetching top answer:", err);
      }
    };

    fetchTopAnswer();
  }, [selectedIndex, topUsers]);

  const renderAnswer = () => {
    const content = topData.topAnswer.content;
    if (content.length <= 160) return content;

    return (
      <>
        {showFullAnswer ? content : `${content.slice(0, 160)}... `}
        <button
          onClick={() => setShowFullAnswer(!showFullAnswer)}
          className="text-cyan-400 underline text-xs sm:text-sm"
        >
          {showFullAnswer ? "View less" : "View more"}
        </button>
      </>
    );
  };

  return (
    <div
      className="w-[320px] sm:w-[480px] md:w-[600px] lg:w-[765px]
           h-[180px] sm:h-[240px] md:h-[300px] lg:h-[340px]
           rounded-[20px] sm:rounded-[25px] lg:rounded-[30px]
           overflow-hidden relative shadow-md bg-black/20 mx-auto
           transition-all duration-500 ease-in-out transform
           hover:scale-[1.015] hover:shadow-2xl hover:brightness-110 group"
    >
      {/* 🖼️ Banner */}
      <img
        src={QuestsBanner}
        alt="Quests Banner"
        className="w-full h-full object-cover transition-all duration-500 ease-in-out group-hover:scale-105 group-hover:blur-[1px]"
      />

      {/* Top Answer Info */}
      <div className="absolute left-[12%] top-[28%] text-left space-y-2
            sm:left-[13%] sm:top-[30%]
            md:left-[14%] md:top-[32%]
            lg:left-[15%] lg:top-[34%]
            transition-all duration-300 ease-in-out group-hover:translate-y-[-2px]">
        {topData && topData.topAnswer ? (
            <>
                <h3 className="text-white text-xs sm:text-sm font-bold leading-snug max-w-[520px]">
                    {topData.quest?.context || "Untitled quest"}
                </h3>
                <p className="text-white text-xs sm:text-sm leading-snug max-w-[520px]">
                    “{renderAnswer()}”
                </p>
            </>
        ) : (
            <div className="text-white text-sm sm:text-base italic">
                Loading this hero’s best moment...
            </div>
        )}
      </div>

    </div>
  );
};

export default HeroCard;
